import React from "react";
import { ToastContainer } from "react-toastify"; // Import ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Import styles
import Header from "./components/header/Header";
import { Route, Routes } from "react-router-dom";
import Homepage from "./pages/homepage/Homepage";
import Footer from "./components/footer/Footer";
import TourPage from "./pages/tours/TourPage";
import TourDetails from "./pages/TourDetails/TourDetails";
import BookNow from "./components/booknow/BookNow";
import AboutUs from "./pages/aboutUs/AboutUs";
import PaymentPage from "./pages/payment/PaymentPage";
import NotFound from "./pages/notfound/NotFound"; // Import NotFound component
import ContactPage from "./pages/contactpage/ContactPage";
import LoginPage from "./pages/login/LoginPage";
import AdminPage from "./pages/admin/AdminPage";
import ProtectedRoute from "./components/ProtectedRoute";
import SubmittedForms from "./components/submittedforms/SubmittedForms";
import DoneBookings from "./components/DoneBooking/DoneBooking";
import DeletedBookings from "./components/deletedbookings/DeletedBookings";

function App() {
  return (
    <>
      <Header />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/tours" element={<TourPage />} />
        <Route path="/tours/:tourName" element={<TourDetails />} />
        <Route path="/tours/book-now" element={<BookNow />} />
        <Route path="/tours/book-now/payment" element={<PaymentPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/tours/*" element={<NotFound />} />
        <Route path="/ttc/login" element={<LoginPage />} />
        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/ttc/admin" element={<AdminPage />}>
            <Route path="submitted" element={<SubmittedForms />} />
            <Route path="done" element={<DoneBookings />} />
            <Route path="deleted" element={<DeletedBookings />} />
          </Route>
        </Route>
      </Routes>
      <Footer />
    </>
  );
}

export default App;
